export const build = {"tag":"v1.0.5","hash":"df071473","time":"261013.1330"}